import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdDataOptions } from '@onefootprint/fetch-dashboard';
import type { Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { getRelevantDis } from '@/components/entity-onboarding-details';
import useEntityVault from '@/entities/hooks/use-entity-vault';

/** The vault as of an onboarding, and whether its "Decrypt all" still has something to decrypt. */
const useOnboardingVault = (entity, onboarding) => {
  const $ = _c(21);
  let t0;
  if ($[0] !== entity.id || $[1] !== onboarding.seqno) {
    t0 = getEntitiesByFpIdDataOptions({
      path: {
        fpId: entity.id
      },
      query: {
        seqno: onboarding.seqno
      }
    });
    $[0] = entity.id;
    $[1] = onboarding.seqno;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = Boolean(entity.id);
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = {
      ...t0,
      enabled: t1
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: entityAttributes
  } = useQuery(t2);
  let t3;
  if ($[6] !== entity.id || $[7] !== entityAttributes || $[8] !== onboarding.seqno) {
    t3 = {
      entityAttributes,
      entityId: entity.id,
      seqno: onboarding.seqno
    };
    $[6] = entity.id;
    $[7] = entityAttributes;
    $[8] = onboarding.seqno;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const vault = useEntityVault(t3);
  let t4;
  if ($[10] !== entityAttributes) {
    t4 = entityAttributes?.some(_temp);
    $[10] = entityAttributes;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const canDecrypt = Boolean(t4);
  let t5;
  if ($[12] !== canDecrypt || $[13] !== entityAttributes || $[14] !== vault) {
    t5 = canDecrypt && getRelevantDis((entityAttributes ?? []).filter(_temp2).map(_temp3)).every(di => vault.isDecrypted(di));
    $[12] = canDecrypt;
    $[13] = entityAttributes;
    $[14] = vault;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const isDecrypted = t5;
  const showDecrypt = canDecrypt ? !isDecrypted : Boolean(entityAttributes?.length);
  let t6;
  if ($[16] !== canDecrypt || $[17] !== isDecrypted || $[18] !== showDecrypt || $[19] !== vault) {
    t6 = {
      vault,
      canDecrypt,
      isDecrypted,
      showDecrypt
    };
    $[16] = canDecrypt;
    $[17] = isDecrypted;
    $[18] = showDecrypt;
    $[19] = vault;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
export default useOnboardingVault;
function _temp(attr) {
  return attr.isDecryptable;
}
function _temp2(attr_0) {
  return attr_0.isDecryptable;
}
function _temp3(attr_1) {
  return attr_1.identifier;
}